import { Action } from '@ngrx/store';
import {HardwareFaultCodes} from '../../../models/events';

export enum HardwareFaultCodeActionTypes {
  LoadHardwareFaultCodes = '[HardwareFaultCode] Load HardwareFaultCodes',
  GetHardwareFaultCodes = '[HardwareFaultCode] Get HardwareFaultCodes',
  GetHardwareFaultCodesFails = '[HardwareFaultCode] Get HardwareFaultCodeFails',
  ChangeLanguageFaultCodes = '[HardwareFaultCode] Change Language FaultCodes',
}

export class LoadHardwareFaultCodes implements Action {
  readonly type = HardwareFaultCodeActionTypes.LoadHardwareFaultCodes;
  constructor(public payload: HardwareFaultCodes[]) {}
}

export class GetHardwareFaultCodes implements Action {
  readonly type = HardwareFaultCodeActionTypes.GetHardwareFaultCodes;
}

export class GetHardwareFaultCodesFails implements Action {
  readonly type = HardwareFaultCodeActionTypes.GetHardwareFaultCodesFails;
}

export class ChangeLanguageFaultCodes implements Action {
  readonly type = HardwareFaultCodeActionTypes.ChangeLanguageFaultCodes;
}


export type HardwareFaultCodeActions = LoadHardwareFaultCodes
  | GetHardwareFaultCodes
  | GetHardwareFaultCodesFails
  | ChangeLanguageFaultCodes;

